import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { Col, Form, Space } from 'antd';
export const FormCompact = ({ label, name, isRequired = false, rules, children, hidden = false, responsive = { xs: 24, xl: 12, xxl: 8 }, disabled, ...restColProps }) => {
    return (_jsx(Col, { ...responsive, ...restColProps, style: { display: hidden ? 'none' : undefined }, children: _jsx(Form.Item, { label: label ? _jsx(_Fragment, { children: label }) : undefined, name: name, required: isRequired, rules: rules, children: _jsx(Space.Compact, { style: { width: '100%' }, children: React.Children.map(children, (child) => {
                    if (React.isValidElement(child)) {
                        return React.cloneElement(child, {
                            ...(disabled !== undefined ? { disabled } : {})
                        });
                    }
                    return child;
                }) }) }) }));
};
